var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.70711 15.707C6.31658 16.0976 5.68357 16.0976 5.29304 15.707C4.90252 15.3165 4.90252 14.6835 5.29304 14.293L11.293 8.29298C11.6836 7.90246 12.3166 7.90246 12.7071 8.29298L18.7071 14.293C19.0976 14.6835 19.0976 15.3165 18.7071 15.707C18.3166 16.0976 17.6836 16.0976 17.293 15.707L12.0001 10.4141L6.70711 15.707Z",
    fill: "#FF4F00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp);
export default __webpack_public_path__ + "static/media/chevron-up.b0156ce908c5c69e301f548e436bc16a.svg";
export { ForwardRef as ReactComponent };